<template>
  <router-view />
</template>

<script>
export default {
  name: 'MedNyttCatalogPage',
};
</script>
